import React from 'react';
import { FormField } from '../../../components/FormField';

interface ApartmentOptionsProps {
  formData: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ApartmentOptions: React.FC<ApartmentOptionsProps> = ({
  formData,
  handleInputChange,
}) => {
  return (
    <div className="space-y-4">
      <FormField label="Options">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                name="hasParking"
                checked={formData.hasParking || false}
                onChange={handleInputChange}
              />
              <span>Parking</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                name="hasAirConditioning"
                checked={formData.hasAirConditioning || false}
                onChange={handleInputChange}
              />
              <span>Climatisation</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                name="hasBalcony"
                checked={formData.hasBalcony || false}
                onChange={handleInputChange}
              />
              <span>Balcon</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                name="hasCellar"
                checked={formData.hasCellar || false}
                onChange={handleInputChange}
              />
              <span>Cave</span>
            </label>
          </div>
          <div className="space-y-2">
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                name="hasElevator"
                checked={formData.hasElevator || false}
                onChange={handleInputChange}
              />
              <span>Ascenseur</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                name="hasIntercom"
                checked={formData.hasIntercom || false}
                onChange={handleInputChange}
              />
              <span>Interphone</span>
            </label>
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                name="hasGuardian"
                checked={formData.hasGuardian || false}
                onChange={handleInputChange}
              />
              <span>Gardien</span>
            </label>
          </div>
        </div>
      </FormField>
    </div>
  );
};